export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAjFjJJw5um-kDyUpJNmQ_kQyYs7C6xM_k',
    authDomain: 'firestore-custom-auth-angular.firebaseapp.com',
    databaseURL: 'https://firestore-custom-auth-angular.firebaseio.com',
    projectId: 'firestore-custom-auth-angular',
    storageBucket: '',
    messagingSenderId: '907228509963',
    appId: '1:907228509963:web:7d90ed1d7bb77b21'
  }
};
